import Dashboard from "layouts/Dashboard/Dashboard.jsx";
var indexRoutes = [{ path: "/", name: "Noticias", component: Dashboard }];

export default indexRoutes;



// WEBPACK FOOTER //
// ./src/routes/redirect.jsx